export default __webpack_public_path__ + "static/media/infra-28.f0512adc.webp";